<script>
import axios from 'axios';

export default {
    name: 'OverviewText',
    data() {
        return {
            text: '',
            heading: ''
        };
    },
    methods: {
        getOverviewText() {
            axios.get('/locations/landing-page-detail').then(({ data }) => {
                this.text = data.overview;
                this.heading = data.heading
            });
        },
    },
    mounted() {
        this.getOverviewText();
    },
};
</script>
<template>
    <div class="overview-text tw-w-full md:tw-w-[300px] tw-space-y-5">
        <h2
            class="tw-text-darkGreen tw-leading-10 tw-text-[40px] md:tw-text-3xl lg: xl:tw-text-5xl tw-font-extrabold"
        >
            Locations
        </h2>
        <h1
            class="tw-text-black tw-font-medium tw-text-[18px] xxl:tw-text-[20px]"
        >
            {{ heading }}
        </h1>
        <h2
            class="tw-text-black tw-font-medium tw-text-[18px] xxl:tw-text-[20px]"
        >
            {{ text }}
        </h2>
    </div>
</template>
